'use strict';

module.exports = {
    SIGN: 'ASSINAR EM',
    SIGN_JOIN: 'Entre ou inscreva-se de graça',
    EMAIL_EXISTS: 'Este e-mail já existe.',
    INVALID_EMAIL: 'Favor adicionar um email válido',
    INVALID_FIRST_NAME: 'Favor adicionar um nome válido',
    INVALID_LAST_NAME: 'Favor adicionar um sobrenome válido',
    INVALID_PASSWORD: 'Favor adicionar 6-20 caratcteres (somente A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'As senhas não são iguais',
    INVALID_VALID_CODE: 'Favor adicionar uma senha valida',
    UNAVIALABLE_SERVICE: 'Servi??o n??o está disponível, por favor, tente novamente mais tarde.',
    EMPTY_VALID_CODE: 'Adicione os caracteres que você ve na figura',
    NOT_MEMBER: 'Você ainda não é um membro?',
    ALREADY_MEMBER: 'Você já é membro do AliExpress/Alibaba?',
    EMAIL: 'Insira seu email',
    CONTACT_NAME: 'Nome para contato:',
    FIRST_NAME: 'Nome',
    LAST_NAME: 'Sobrenome',
    PASSWORD: 'Senha',
    REPASSWORD: 'Adicione a senha novamente:',
    EMPTY_CODE: 'Adicione o código',
    REFRESH: 'Refrescar',
    CREATE_MY_ACCOUNT: 'Criar a minha conta',
    NAME: 'Nome',
    VERIFICATION: 'Código de verificação',
    AGREE_MENT: 'Ao criar uma conta, você concorda com o',
    AE_MEMBER_SHIP: 'Contrato de Associação Livre AliExpress.com',
    AND: 'e',
    PRIVACY_POLICY: 'Política de Privacidade',
    SLIDE_SUBMIT: 'Deslize para a direita para confirmar',
    SLIDE_SUBMIT_TIPS: 'Sucesso',
    LOADING: 'Carregando...',
    SLIDE_SUBMIT_ERROR_TIPS: 'Deslize para a direita para confirmar',
    SHOP_NOW: 'CONFIRA!',
    SIGN_IN: 'Entrar',
    REGISTER_SMS: 'Cadastrar por SMS',
    REGISTER_EMAIL: 'Cadastrar por email',
    PHONE_NUMBER: 'Número de Telefone',
    VALID_NUMBER: 'Insira um número de telefone válido',
    SEND_SMS_CODE: 'Enviar SMS',
    SMS_POLICY: 'Você receberá um código de verificação por mensagem no número de celular inserido. Certifique-se de que o código do país e número do telefone estejam corretos.',
    SEND_TO: 'O código foi enviado para',
    VERIFICATION_RECEIVED: 'Insira o código de verificação recebido ou',
    EDIT_NUMBER: 'modifique o número.',
    RESEND_CODE: 'Reenviar o Código',
    LAST_STEP: 'Última Etapa',
    SET_SIGN_IN_PASSWORD: 'Defina uma senha de acesso para tornar sua conta mais segura.',
    INVALID_PHONE_PASSWORD: '6 - 20 caracteres (apenas letras e números)',
    NOT_CORRECT_CODE: 'Código incorreto, tente de novo.',
    SAVE_PASSWORD: 'Salvar Senha',
    NO_RECEIVED_CODE: 'Se você ainda não recebeu o código, tente',
    VIA_EMAIL: 'fazer o cadastro via email.'
};